import StringCell from "@isceco/widget-library2/basic-elements/List/cell/StringCell";
import '@isceco/widget-library2/basic-elements/Popup/Popup.js'
import {html} from "@isceco/widget-library2/external/lit";

export default class HelpTextCell extends StringCell {

  constructor(configuration) {
    super(configuration);
    this.helpTextDirection = configuration.helpTextDirection;
    this.helpTextArray = configuration.helpTextArray;
  }

  render(i18n, cell, row) {
    return html`
      <div style="display: flex; flex-direction: row; align-items: center">
        ${super.render(i18n, cell)}
        ${this._renderPopup(row)}
      </div>
    `
  }

  _renderPopup(row) {
    const helpTextArray = this.helpTextArray(row)
    if (helpTextArray.length === 0) {
      return html``
    }
    return html`
      <isceco-popup
      style="margin-left: var(--isceco-space-100)"
      direction="${isEmpty(this.helpTextDirection) ? 'up' : this.helpTextDirection}">
      <i slot="wrapper" class="info circle icon"></i>
      <div slot="content">
        ${helpTextArray.map(text => html`<div>${text}</div>`)}
      </div>
    </isceco-popup>
    `
  }
}
